import loadGoogleMapsApi from 'load-google-maps-api'

export default function googleMaps($mapContainer) {

  loadGoogleMapsApi({
    key: 'AIzaSyDZCetLphqG5rr0Hsp396vJTVA29AnOi8w'
  }).then(function (googleMaps) {

    const latlng = $mapContainer.getAttribute('data-latlng').split(',').map(coord => { return parseFloat(coord, 10) })

    const map = new googleMaps.Map($mapContainer, {
      center: {
        lat: latlng[0],
        lng: latlng[1]
      },
      zoom: 15,
      styles: [{"featureType":"administrative","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"administrative.province","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape","elementType":"all","stylers":[{"saturation":-100},{"lightness":65},{"visibility":"on"}]},{"featureType":"poi","elementType":"all","stylers":[{"saturation":-100},{"lightness":"50"},{"visibility":"simplified"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":"-100"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"all","stylers":[{"lightness":"30"}]},{"featureType":"road.local","elementType":"all","stylers":[{"lightness":"40"}]},{"featureType":"transit","elementType":"all","stylers":[{"saturation":-100},{"visibility":"simplified"}]},{"featureType":"water","elementType":"geometry","stylers":[{"hue":"#ffff00"},{"lightness":-25},{"saturation":-97}]},{"featureType":"water","elementType":"labels","stylers":[{"lightness":-25},{"saturation":-100}]}]
    })

    const markerLatLngs = eval($mapContainer.getAttribute('data-markers'))

    markerLatLngs.forEach(marker => {
      let m = marker.split(',').map(coord => { return parseFloat(coord, 10) })
      m = new googleMaps.Marker({
        position: {
          lat: m[0],
          lng: m[1]
        },
        map: map
      })
    })

  }).catch(function (error) {
    console.error(error)
  })
}



// WEBPACK FOOTER //
// ./src/js/ui/google-maps.js